import React, { createContext, useContext, useEffect, useState } from 'react'
import { getPeriodoFromLastXDays, getPeriodoMesAtual } from '../services/util/date.service'

const OrdemColetaContext = createContext()

const INITIAL_STATE = {
  ordemColeta: {
    selectedPeriodo: getPeriodoMesAtual(),
  },
  analiseOcorrencia: {
    selectedPeriodo: getPeriodoMesAtual(),
    selectedCentral: '',
    data: '',
  },
  ocorrenciaColaborador: {
    selectedPeriodo: getPeriodoMesAtual(),
    selectedEmpresa: '',
    data: '',
  },
  ocorrenciasPendentes: {
    selectedPeriodo: getPeriodoFromLastXDays(31),
  },
}

export const OrdemColetaProvider = ({ children }) => {
  const [ordemColetaContext, setOrdemColetaContext] = useState(INITIAL_STATE)
  const [analiseOcorrenciaContext, setAnaliseOcorrenciaContext] = useState(
    ordemColetaContext.analiseOcorrencia,
  )
  const [ocorrenciaColaboradorContext, setOcorrenciaColaboradorContext] = useState(
    ordemColetaContext.ocorrenciaColaborador,
  )
  const [ordensColetaContext, setOrdensColetaContext] = useState(ordemColetaContext.ordemColeta)
  const [ocorrenciasPendentesContext, setOcorrenciasPendentesContext] = useState(
    ordemColetaContext.ocorrenciasPendentes,
  )

  return (
    <OrdemColetaContext.Provider
      value={{
        ordemColetaContext,
        setOrdemColetaContext,
        analiseOcorrenciaContext,
        setAnaliseOcorrenciaContext,
        ocorrenciaColaboradorContext,
        setOcorrenciaColaboradorContext,
        ordensColetaContext,
        setOrdensColetaContext,
        ocorrenciasPendentesContext,
        setOcorrenciasPendentesContext,
      }}
    >
      {children}
    </OrdemColetaContext.Provider>
  )
}

export const useOrdemColetaContext = () => {
  const { ordemColetaContext, setOrdemColetaContext } = useContext(OrdemColetaContext)
  return { ordemColetaContext, setOrdemColetaContext }
}

export const useAnaliseOcorrenciaContext = () => {
  const { setOrdemColetaContext } = useContext(OrdemColetaContext)
  const { analiseOcorrenciaContext, setAnaliseOcorrenciaContext } = useContext(OrdemColetaContext)

  useEffect(() => {
    setOrdemColetaContext(prevOrdemColetaContext => ({
      ...prevOrdemColetaContext,
      analiseOcorrencia: analiseOcorrenciaContext,
    }))
  }, [analiseOcorrenciaContext])

  return { analiseOcorrenciaContext, setAnaliseOcorrenciaContext }
}

export const useOcorrenciaColaboradorContext = () => {
  const { setOrdemColetaContext } = useContext(OrdemColetaContext)
  const { ocorrenciaColaboradorContext, setOcorrenciaColaboradorContext } =
    useContext(OrdemColetaContext)

  useEffect(() => {
    setOrdemColetaContext(prevOrdemColetaContext => ({
      ...prevOrdemColetaContext,
      ocorrenciaColaborador: ocorrenciaColaboradorContext,
    }))
  }, [ocorrenciaColaboradorContext])

  return { ocorrenciaColaboradorContext, setOcorrenciaColaboradorContext }
}

export const useOrdensColetaContext = () => {
  const { setOrdemColetaContext } = useContext(OrdemColetaContext)
  const { ordensColetaContext, setOrdensColetaContext } = useContext(OrdemColetaContext)

  useEffect(() => {
    setOrdemColetaContext(prevOrdemColetaContext => ({
      ...prevOrdemColetaContext,
      ordensColetaContext: ordensColetaContext,
    }))
  }, [ordensColetaContext])

  return { ordensColetaContext, setOrdensColetaContext }
}

export const useOcorrenciasPendentesContext = () => {
  const { setOrdemColetaContext } = useContext(OrdemColetaContext)
  const { ocorrenciasPendentesContext, setOcorrenciasPendentesContext } =
    useContext(OrdemColetaContext)

  useEffect(() => {
    setOrdemColetaContext(prevOrdemColetaContext => ({
      ...prevOrdemColetaContext,
      ocorrenciasPendentes: ocorrenciasPendentesContext,
    }))
  }, [ocorrenciasPendentesContext])

  return { ocorrenciasPendentesContext, setOcorrenciasPendentesContext }
}
